import Vue from 'vue'
import './pollyfills'
import VueSignaturePad from 'vue-signature-pad'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'

import store from './store'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Select from 'element-ui/lib/select'

// Fix for element ui filters not working on mobile
Select.computed.readonly = function () {
  // trade-off for IE input readonly problem: https://github.com/ElemeFE/element/issues/10403
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode))
  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia

  if (this.filterable) {
    return !(this.filterable || this.multiple || !isIE && !isEdge) && !this.visible
  }

  return !this.filterable || this.multiple || !isIE && !isEdge && !this.visible
}

Vue.use(VueFormWizard)
Vue.use(VueRouter)
Vue.use(VueSignaturePad)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, { sidebarLinks: sidebarLinks })
Vue.use(VeeValidate)
locale.use(lang)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js